export const headers = {
    active_sporting: {
        title: 'sportProfile.roleType.activePlaying',
        baseIcon: 'sn-heart',
        iconClassName: 'sn-heart sn-lg text-color-negative',
        borderColor: 'red',
        relationId: 1,
    },
    cheer: {
        title: 'sportProfile.roleType.cheer',
        baseIcon: 'sn-fans',
        iconClassName: 'sn-fans text-color-brand sn-lg',
        borderColor: 'green',
        relationId: 3,
    },
    active_coach: {
        title: 'sportProfile.roleType.activeCoach',
        baseIcon: 'sn-stopwatch',
        iconClassName: 'sn-stopwatch text-color-neutral sn-lg',
        borderColor: 'neutral',
        relationId: 2,
    },
    parent_support: {
        title: 'sportProfile.roleType.parentSupport',
        baseIcon: 'sn-for-kids',
        iconClassName: 'sn-for-kids text-color-warning sn-lg',
        borderColor: 'warning',
        relationId: 4,
    },
    manager: {
        title: 'sportProfile.roleType.manager',
        baseIcon: 'sn-for-kids',
        iconClassName: 'sn-manager text-color-organizer sn-lg',
        borderColor: 'organizer',
        relationId: 12,
    },
    referee: {
        title: 'sportProfile.roleType.referee',
        baseIcon: 'sn-notification-2',
        iconClassName: 'sn-notification-2 text-color-grey sn-lg',
        borderColor: 'grey',
        relationId: 5,
    },
    history: {
        title: 'sportProfile.history',
        baseIcon: 'sn-for-kids',
        iconClassName: 'sn-for-kids text-color-warning sn-lg',
    },
    other: {
        title: 'sportProfile.roleType.others',
        baseIcon: 'sn-logo-sn',
        iconClassName: 'sn-logo-sn text-color-grey sn-lg',
        borderColor: 'grey',
        relationId: 13,
    },
}
